/* eslint-disable no-unused-vars */
import React, { useState, useRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'utils/makeStylesAdapter';
import Hidden from 'components/Hidden';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  colors,
  Typography,
  Tooltip,
} from '@mui/material';
import InputIcon from '@mui/icons-material/Input';
import MenuIcon from '@mui/icons-material/Menu';
import ColorLensIcon from '@mui/icons-material/WbSunny';
import useRouter from 'utils/useRouter';
import { NotificationsPopover } from 'components';
import { clearAiMessages, logout, TOGGLE_LIGHT_THEME } from 'actions';
import { GroupsMenu } from './components';
import './TopBar.css';
import LogoConsensus from '../../../../assets/images/logoConsensus2.png';
import { EnvTypes } from 'constants/envTypes';
import { useParameterKeys } from 'hooks/useParameterKeys';

const useStyles = makeStyles(theme => ({
  root: {
    boxShadow: 'none',
    backgroundColor: ({ isLightTheme }) => (isLightTheme ? '#d1e7f1' : '#00597b'),
    borderColor: ({ isLightTheme }) => (isLightTheme ? '#d1e7f1' : '#00597b'),
    color: ({ isLightTheme }) => (isLightTheme ? '#000000' : '#ffffff'),
    height: 60,
    justifyContent: 'center',
  },
  flexGrow: {
    flexGrow: 1,
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: 'inherit',
  },
  searchInput: {
    flexGrow: 1,
    color: 'inherit',
    '& input::placeholder': {
      opacity: 1,
      color: 'inherit',
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
  },
  searchPopperContent: {
    marginTop: theme.spacing(1),
  },
  notificationsButton: {
    marginLeft: theme.spacing(1),
  },
  notificationsBadge: {
    backgroundColor: colors.orange[600],
  },
  envTypeConsensus: {
    color: 'yellow',
    marginRight: 100,
    marginTop: 10,
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  avatar: {
    borderRadius: 50,
    paddingTop: 1,
  },
  containerLinks: {
    paddingLeft: 100,
  },
  nameUserStyle: {
    fontSize: 12,
    color: ({ isLightTheme }) => (isLightTheme ? '#000000' : '#ffffff'),
    marginRight: 10,
    fontFamily: 'Roboto-Regular',
  },
}));

const TopBar = props => {
  const { onOpenNavBarMobile, className, ...rest } = props;

  const { applyLightTheme, isMPDFT } = useParameterKeys();
  const classes = useStyles({ isLightTheme: applyLightTheme });
  const { history } = useRouter();
  const dispatch = useDispatch();
  const notificationsRef = useRef(null);
  const [notifications, setNotifications] = useState([]);
  const [openNotifications, setOpenNotifications] = useState(false);

  const nameUser = useSelector(state => state.logedUser.name);
  const userId = useSelector(state => state.logedUser.userId);
  const { currentEnviromentType, useLightTheme } = useSelector(state => state.session);

  const handleToggleLightTheme = () => {
    const newValue = !useLightTheme;
    dispatch({ type: TOGGLE_LIGHT_THEME });
    if (userId) {
      localStorage.setItem(`lightTheme_${userId}`, String(newValue));
    }
  };

  const handleLogout = () => {
    history.push('/');
    dispatch(clearAiMessages());
    dispatch(logout());
  };

  const handleNotificationsOpen = () => {
    setOpenNotifications(true);
  };

  const handleNotificationsClose = () => {
    setOpenNotifications(false);
  };

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <RouterLink to="/Dashboard" style={{ paddingTop: 5 }}>
          <img alt="Consensus" height="40" src={LogoConsensus} />
        </RouterLink>
        <ul className="header">
          <li>
            <RouterLink
              to="/Dashboard"
              style={{ fontSize: 18, color: applyLightTheme ? '#000000' : '#ffffff' }}
            >
              CONSENSUS
            </RouterLink>
          </li>
        </ul>
        {isMPDFT && (
          <Tooltip arrow title={useLightTheme ? 'Desativar tema claro' : 'Ativar tema claro'}>
            <IconButton
              onClick={handleToggleLightTheme}
              style={{ color: applyLightTheme ? '#000000' : '#ffffff', marginLeft: 4 }}
              size="small"
            >
              <ColorLensIcon fontSize="small" style={{ opacity: useLightTheme ? 1 : 0.6 }} />
            </IconButton>
          </Tooltip>
        )}
        <div className={classes.flexGrow} />
        <div className={classes.centeredTypography}>
          <Typography gutterBottom variant="h3" className={classes.envTypeConsensus}>
            {currentEnviromentType === EnvTypes.DEV
              ? 'DESENVOLVIMENTO'
              : currentEnviromentType === EnvTypes.HML
              ? 'HOMOLOGAÇÃO'
              : currentEnviromentType === EnvTypes.TRN
              ? 'TREINAMENTO'
              : ''}
          </Typography>
        </div>
        <GroupsMenu />
        <Hidden mdDown>
          {/*<IconButton
                        className={classes.notificationsButton}
                        color="inherit"
                        onClick={handleNotificationsOpen}
                        ref={notificationsRef}
                        >
                        <Badge
                            badgeContent={notifications.length}
                            classes={{ badge: classes.notificationsBadge }}
                            variant="dot"
                        >
                            <NotificationsIcon />
                        </Badge>
                    </IconButton>*/}
          <Box className={classes.nameUserStyle}>
            <span>{nameUser}</span>
          </Box>
          <Button className={classes.logoutButton} color="inherit" onClick={handleLogout} to="/">
            <InputIcon className={classes.logoutIcon} />
            Sair
          </Button>
        </Hidden>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onOpenNavBarMobile}>
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
      <NotificationsPopover
        anchorEl={notificationsRef.current}
        notifications={notifications}
        onClose={handleNotificationsClose}
        open={openNotifications}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
